import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

import RichTextField from '@ts-core/components/RichTextField';
import Button from '@ts-core/components/Button';

const AnswerForm = (props) => {
  const { submitting, answer, onSubmit } = props;
  const [isFormBusy, setIsFormBusy] = useState(false);

  const [content, setContent] = useState(answer?.content);

  const handleOnSubmit = useCallback(() => {
    onSubmit({ content });
  }, [onSubmit, content]);

  return (
    <Box width="100%">
      <RichTextField value={content} onChange={setContent} onBusyStatsChange={setIsFormBusy} />
      <Box mt={2} width="100%" display="flex" justifyContent="flex-end">
        <Button loading={submitting} disabled={!content || isFormBusy} color="primary" onClick={handleOnSubmit}>
          <FormattedMessage id="forum.form.submitButton" defaultMessage="Enviar" />
        </Button>
      </Box>
    </Box>
  );
};

AnswerForm.propTypes = {
  submitting: PropTypes.bool,
  answer: PropTypes.object,

  onSubmit: PropTypes.func,
};

AnswerForm.defaultProps = {
  submitting: false,
  answer: {},

  onSubmit() {},
};

export default AnswerForm;
